import React from 'react'
import { useHistory } from 'react-router-dom'
import {
  Box,
  Button,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Chip,
  Grid,
  Divider,
  Typography,
  CircularProgress,
} from '@material-ui/core'
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite'
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode'
import clsx from 'clsx'
import WhatsNewFeedback from '../feedbackModal/WhatsNewFeedback'
import VideoPlayer from './VideoPlayer'
import styles from './WhatsNewItemCardStyles'
import { getImageFromFirebaseWithHook } from '../../../../helpers'

const WhatsNewCard = ({ item, idx }) => {
  const [image, setImage] = React.useState('')
  const [showVideoPrev, setShowVideoPrev] = React.useState(false)
  const [mouseOverPreview, setMouseOverPreview] = React.useState(false)
  const [enableMouseOverPreview, setEnableMouseOverPreview] =
    React.useState(false)

  React.useEffect(() => {
    getImageFromFirebaseWithHook(item.image, setImage)
  }, [])
  console.log('item in card', idx, 'item image', image)
  // function to enable/disable onMouse ober show video preview
  // required to prevent showing preview while the video is not loaded or ready to be played
  React.useEffect(() => {
    if (showVideoPrev) {
      setEnableMouseOverPreview(true)
    }
  }, [showVideoPrev])

  const classes = styles({ showVideoPrev })
  const history = useHistory()

  function isYouTubeUrl(url) {
    const regex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/
    return regex.test(url)
  }
  function handleMouseOver() {
    if (!showVideoPrev && enableMouseOverPreview) {
      setMouseOverPreview(true)
    }
  }

  function handleClick() {
    history.push(`/WhatsNewArticle/${item.title}`)
  }

  return (
    <Card className={classes.itemCardContainer}>
      <>
        {isYouTubeUrl(item?.link) ? (
          <>
            <VideoPlayer
              idx={idx}
              setShowVideoPrev={setShowVideoPrev}
              mouseOverPreview={mouseOverPreview}
              setMouseOverPreview={setMouseOverPreview}
              assetUrl={item?.link}
            />
            <Box
              className={classes.previewDisplay}
              onMouseEnter={handleMouseOver}
            >
              {image ? (
                <CardMedia
                  className={clsx(classes.imageDisplay, {
                    [classes.active]: showVideoPrev,
                    [classes.inactive]: !showVideoPrev,
                  })}
                  image={image}
                  title={item.imageAlt}
                  component="img"
                />
              ) : (
                <Box className={classes.loadingDisplay}>
                  <CircularProgress className={classes.loadingSpinner} />
                </Box>
              )}
            </Box>
          </>
        ) : (
          <CardMedia
            className={classes.image}
            image={image}
            title={item.imageAlt}
            component="div"
          ></CardMedia>
        )}
      </>

      <CardActions>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Button
              variant="contained"
              className={classes.articleLinkButton}
              onClick={handleClick}
            >
              {item.type.toLowerCase() === 'video' ? (
                <>
                  <PlayCircleFilledWhiteIcon className={classes.playIcon} />
                  &nbsp;See more
                </>
              ) : (
                <>
                  <ChromeReaderModeIcon />
                  &nbsp;Read more
                </>
              )}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <WhatsNewFeedback incomingTitle={item.title} isLarge />
          </Grid>
        </Grid>
      </CardActions>

      <CardContent>
        <Typography variant="h4" className={classes.itemTitle}>
          <b>{item.title}</b>
        </Typography>
        <Divider />

        <Typography variant="body1" className={classes.itemDescription}>
          {item.description}
        </Typography>
        <Divider />
        <Box className={classes.tagList}>
          {item.tags.slice(0, 3).map((tag) => (
            <Chip className={classes.tagItem} key={`${tag}$`} label={tag} />
          ))}
          {item.tags.length > 3 && (
            <Chip className={classes.tagItem} key="last$" label="..." />
          )}
        </Box>
      </CardContent>
    </Card>
  )
}

export default WhatsNewCard
